import dayjs from "dayjs";

export const formatCurrency = (value) => `$${Number(value ?? 0).toFixed(2)}`;

export const calculateTotalCost = (service) => {
  const q = service?.QuoteWorkScopeServices;
  let costPerSf = 0, serviceCost = 0, monthlyRate = 0;
  if (q?.baseR) {
    costPerSf += q.baseR.costPerSf || 0;
    serviceCost += q.baseR.serviceCost || 0;
    monthlyRate += q.baseR.monthlyRate || 0;
  }
  if (q?.milea) {
    costPerSf += q.milea.mileageCostPerSf || 0;
    serviceCost += q.milea.mileageServiceCost || 0;
    monthlyRate += q.milea.mileageMonthlyCost || 0;
  }
  if (q?.super) {
    costPerSf += q.super.costPerSf || 0;
    serviceCost += q.super.serviceCost || 0;
    monthlyRate += q.super.monthlyRate || 0;
  }
  return { costPerSf, serviceCost, monthlyRate };
};

export const dataURLtoBlob = (dataUrl) => {
  if (!dataUrl) return null;
  const [meta, b64] = dataUrl.split(",");
  const mime = /:(.*?);/.exec(meta)?.[1] || "image/png";
  const bin = atob(b64 || "");
  const len = bin.length;
  const u8 = new Uint8Array(len);
  for (let i = 0; i < len; i++) u8[i] = bin.charCodeAt(i);
  return new Blob([u8], { type: mime });
};


export const selectionToUtcRange = (selectedSchedule, contractOverride) => {
  if (!selectedSchedule || !contractOverride?.length) {
    console.warn("⚠️ No hay selección o contractOverride vacío");
    return { startDateUTC: null, endDateUTC: null };
  }

  const [dateIndex, hourIndex] = String(selectedSchedule)
    .split("-")
    .map((n) => Number(n));

  const block = contractOverride?.[dateIndex];
  const hour = block?.hours?.[hourIndex];

  if (!block || !hour) {
    console.warn("⚠️ selectionToUtcRange: bloque u hora inválidos", { block, hour });
    return { startDateUTC: null, endDateUTC: null };
  }

  const baseStart = dayjs(block.startDate);
  const baseEnd = dayjs(block.endDate);

  let start;
  if (dayjs(hour.startHour).isValid() && hour.startHour.includes("T")) {
    start = dayjs(hour.startHour);
  } else if (hour.startHour?.includes(":")) {
    const [sh, sm] = hour.startHour.split(":").map(Number);
    start = baseStart.hour(sh).minute(sm).second(0);
  } else {
    start = baseStart;
  }

  let end;
  if (dayjs(hour.endHour).isValid() && hour.endHour.includes("T")) {
    end = dayjs(hour.endHour);
  } else if (hour.endHour?.includes(":")) {
    const [eh, em] = hour.endHour.split(":").map(Number);
    end = baseEnd.hour(eh).minute(em).second(0);
  } else {
    end = baseEnd;
  }

  if (!start.isValid() || !end.isValid()) {
    console.error("❌ Fechas inválidas en selectionToUtcRange:", { start, end });
    return { startDateUTC: null, endDateUTC: null };
  }

  const startDateUTC = start.utc().toISOString();
  const endDateUTC = end.utc().toISOString();

  return { startDateUTC, endDateUTC };
};


export const deriveFromSummary = (jobSummary) => {
  const data = {
    id: jobSummary?.id,
    workTypeId: jobSummary?.workScope?.id,
    createdAt: jobSummary?.createdAt,
    updatedAt: jobSummary?.updatedAt,
    workType: jobSummary?.workScope?.workType,     // { type, name }
    quotes: jobSummary?.workScope?.quotes,
  };
  const quote = jobSummary?.workScope?.quotes?.[0];
  const contractOverride = quote?.contractOverride;
  const workScopeServices = quote?.workScopeServices;
  return { data, quote, contractOverride, workScopeServices };
};

export const isCommercialService = (currentData) =>
  currentData?.workType?.type === "commercial";

export const isReadOnlyStatus = (currentData) =>
  currentData?.status !== "forRevision";
